module.exports = __webpack_public_path__ + "static/media/subICloud3.ff6233b0.png";